import { required } from '@vee-validate/rules'
import { defineRule } from 'vee-validate'
// import defineRule from '../defineRule'

// defineRule('required', (value, [], { field }) => {
//   return required(value) || `${field} is required`
// })

defineRule('required', required)
